import useChallengeArticleContext from "@/challenges/utils/useChallengeArticleContext";
import useIsAuthorizedForIndependentReadingChallenge from "@/challenges/utils/useIsAuthorizedForIndependentReadingChallenge/useIsAuthorizedForIndependentReadingChallenge";
import ChallengeEarnedTokenContent from "@/view/ArticleActivityPicker/ChallengeEarnedTokenContent";
import PowerWordQuizResponseItem from "../PowerWordQuizResponseItem";
import PowerWordSummaryInfo from "../PowerWordSummaryInfo";
import {
  dividerCss,
  responseItemContainerCss,
} from "../QuizSummary/QuizSummary.style";
import SummaryItemCount from "../QuizSummary/SummaryItemCount";
import getPowerWordsPoints from "../utils/getPowerWordsPoints";

interface PowerWordQuizSummaryProps {
  sanitizedStudentPowerWordQuizData: any[];
}

const PowerWordQuizSummary = ({
  sanitizedStudentPowerWordQuizData,
}: PowerWordQuizSummaryProps) => {
  const isAuthorizedChallengesPageUser =
    useIsAuthorizedForIndependentReadingChallenge();
  const { articleData } = useChallengeArticleContext();

  const getTotalQuestions = () => sanitizedStudentPowerWordQuizData.length * 2;
  const getTotalAnswersCorrect = () => {
    const totalQuestionsAnswered = sanitizedStudentPowerWordQuizData.map(
      (question) => question?.isCorrect,
    );

    return totalQuestionsAnswered
      .flatMap((x) => x)
      .filter((isCorrect) => isCorrect === true).length;
  };

  const renderQuizResponseItem = (question: any, index: number) => (
    <PowerWordQuizResponseItem
      key={`question-item-${index}`}
      question={question}
    />
  );

  return (
    <>
      <SummaryItemCount
        correctAnswerCount={getTotalAnswersCorrect()}
        isPowerWordQuiz
        points={getPowerWordsPoints(
          getTotalQuestions(),
          getTotalAnswersCorrect(),
        )}
        count={getTotalQuestions()}
      />
      {isAuthorizedChallengesPageUser && (
        <ChallengeEarnedTokenContent
          isStudent
          articleData={articleData}
          type="Power Words"
        />
      )}
      <PowerWordSummaryInfo
        correctAnswerCount={getTotalAnswersCorrect()}
        totalQuestionsCount={getTotalQuestions()}
        points={getPowerWordsPoints(
          getTotalQuestions(),
          getTotalAnswersCorrect(),
        )}
      />
      <div css={responseItemContainerCss}>
        {sanitizedStudentPowerWordQuizData?.map((question, index) => {
          return (
            <div key={`question-item-${index}`}>
              {renderQuizResponseItem(question, index)}
              {index !== sanitizedStudentPowerWordQuizData.length - 1 && (
                <div css={dividerCss} />
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default PowerWordQuizSummary;
